import { render, staticRenderFns } from "./ExamRecordDetail.vue?vue&type=template&id=36221936&scoped=true"
import script from "./ExamRecordDetail.vue?vue&type=script&lang=js"
export * from "./ExamRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./ExamRecordDetail.vue?vue&type=style&index=0&id=36221936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36221936",
  null
  
)

export default component.exports